
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"19","height":"19","viewBox":"0 0 19 19"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"#697485","data-name":"vuesax/twotone/document-text"}},[_c('path',{attrs:{"d":"M6.331.99h6.333a4.5 4.5 0 013.456 1.278 4.646 4.646 0 011.1 3.274v7.917a4.646 4.646 0 01-1.1 3.274 4.5 4.5 0 01-3.453 1.278H6.331a4.5 4.5 0 01-3.451-1.278 4.646 4.646 0 01-1.1-3.274V5.54a4.646 4.646 0 011.1-3.272A4.5 4.5 0 016.331.99zm6.333 15.833a3.381 3.381 0 002.583-.9 3.516 3.516 0 00.781-2.466V5.54a3.516 3.516 0 00-.781-2.466 3.381 3.381 0 00-2.583-.9H6.331a3.381 3.381 0 00-2.583.9 3.516 3.516 0 00-.779 2.466v7.917a3.516 3.516 0 00.781 2.466 3.381 3.381 0 002.583.9z"}}),_c('path',{attrs:{"data-name":"Vector","d":"M14.645 7.319h-1.583a2.18 2.18 0 01-2.177-2.173V3.563a.594.594 0 01.594-.594.594.594 0 01.594.594v1.583a.991.991 0 00.99.99h1.582a.594.594 0 010 1.188zM9.5 10.886H6.334a.594.594 0 01-.594-.594.594.594 0 01.594-.594H9.5a.594.594 0 01.59.594.594.594 0 01-.59.594zM12.667 14.053H6.334a.594.594 0 01-.594-.594.594.594 0 01.594-.594h6.333a.594.594 0 01.594.594.594.594 0 01-.594.594z","opacity":".4"}})])])
          )
        }
      }
    